import "@babel/polyfill";
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import messages from '@/lang/en'
import {i18n} from './api/i18n-setup'

import '@/api/feathers-client'

import logger from '@/api/logger'

import iView from 'iview';
import 'iview/dist/styles/iview.css';
import './less/lc-iview.less'
//import lang from 'iview/dist/locale/en-US';


import moment from 'vue-moment'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = true;
Vue.config.performance = true;

/*

import { locale, Row, Col, Card, Form, FormItem, Input, Checkbox, Button, Select, Option, Layout, Content, Sider, Menu, MenuItem, Avatar, Header, Divider, Alert, Message, Notice} from 'iview';
//locale(lang);
Vue.component('Row', Row);
Vue.component('Col', Col);
Vue.component('Card', Card);
Vue.component('Form', Form);
Vue.component('FormItem', FormItem);
Vue.component('Input', Input);
Vue.component('Checkbox', Checkbox);
Vue.component('Button', Button);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('Layout', Layout);
Vue.component('Sider', Sider);
Vue.component('Content', Content);
Vue.component('Menu', Menu);
Vue.component('MenuItem', MenuItem);
Vue.component('Avatar', Avatar);
Vue.component('Header', Header);
Vue.component('Divider', Divider);
Vue.component('Alert', Alert);
Vue.component('Message', Message);
Vue.component('Notice', Notice);
*/


Vue.use(iView);
Vue.use(moment);
Vue.use(VueCookies);


new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')